import React from 'react';
import { Grid } from '@mui/material';
import ToolBreadcrumb from 'components/Common/ToolBreadcrumb';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
  handleRefresh?: any;
  setTabState?: any;
  onDatabaseCreated?: (databaseId: string) => void;
  onDatabaseUploadFailed?: (databaseId: string) => void;
  databaseId?: string;
  databaseName?: string;
  htsCode?: string;
  // When set, renders a "🏠 hubLabel > ... > title" breadcrumb above the
  // page title for pages that drill into a specific record, matching the
  // Import Hub pattern.
  hubLabel?: string;
  hubTo?: string;
}

const DBModuleHeaderLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const { children, title, databaseId, htsCode, databaseName, hubLabel, hubTo } =
    props;

  // Helper for the Chevron separator
  const Chevron = () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M6 12L10 8L6 4'
        stroke='var(--bread-crumbs)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

  const digitsOnly = (s = '') => String(s).replace(/\D/g, '');

  const formatHtsPretty = (raw = '') => {
    const d = digitsOnly(String(raw));
    const parts = [d.slice(0, 4)];
    if (d.length > 4) {
      parts.push(d.slice(4, 6));
    }
    if (d.length > 6) {
      parts.push(d.slice(6, 10));
    }
    return parts.filter(Boolean).join('.');
  };

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            {hubLabel && (
              <ToolBreadcrumb
                items={[
                  { label: hubLabel, to: hubTo },
                  ...(title !== 'Product DB' && databaseId && databaseName
                    ? [{ label: databaseName, to: `/database/${databaseId}` }]
                    : []),
                  { label: title },
                ]}
              />
            )}
            <div className='module-header-breadcrumbs'>
              <h1 className='analyzers-page-title'>{title}</h1>
              {htsCode && databaseId && <Chevron />}
              {htsCode && databaseId && (
                <div className='bc-title' style={{ cursor: 'pointer' }}>
                  {formatHtsPretty(htsCode)}
                </div>
              )}
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default DBModuleHeaderLayout;
